<div class="container" style="background-color: #ccc">
    <div class="wrap2">
        <div id="seachform">
            <form novalidate="" class="ng-pristine ng-valid ng-touched">
                <table border="0" cellpadding="0" cellspacing="0">
                    <tbody>
                        <tr>
                            <td class="collaps">
                                <div class="text w-100 loading-animate"></div>
                            </td>
                            <td class="collaps">
                                <div class="text w-100 loading-animate"></div>
                            </td>
                            <td class="collaps">

                                <div class="text w-100 loading-animate"></div>
                            </td>
                            <td class="collaps">

                                <div class="text w-100 loading-animate"></div>
                            </td>
                            <td id="button-space">
                                <div class="text w-100 loading-animate"></div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div class="errors"><span id="errorBarco"></span><span id="errorDias"></span><span id="errorfecha"></span><span id="errorpax"></span>
                </div>
            </form>
        </div>
    </div>
</div>